module.exports = __webpack_public_path__ + "static/media/hours-icon-over.48332267.svg";